@if (isUserUnAuthorized) {
  <app-un-authorized [errorStatusCode]="errorStatusCode"></app-un-authorized>
} @else {
  @if (weavyData) {
    <app-notification-settings [isMobile]="weavyData?.isMobileScreen"></app-notification-settings>
  }
  <div [ngClass]="{ 'post-full-screen': isFullScreen, 'mobile-view': weavyData?.isMobileScreen }">
    <div class="download-posts post-full-screen-download-container" [ngClass]="{ 'no-padding': weavyData?.isIhubScreen, 'p-sticky': !weavyData?.isMobileScreen }">
      @if (!isApplicationRunningOnOnItSystem && !weavyData?.isMobileScreen) {
        <button class="download-posts-button-container" (click)="downloadPosts()"
          [matTooltip]="weavyData?.isIhubScreen ? 'Download Posts' : ''">
          <img [src]="'images/pdf-dw.svg' | assetUrl" alt="pdf" class="download-posts-button-container-img" />
          <span [hidden]="weavyData?.isIhubScreen && !ihubMaximizeFlag"
          class="download-posts-button-container-title">Download Posts</span>
        </button>
        <button class="download-posts-button-container" (click)="downloadPostsAndPolicyDocs()"
          [matTooltip]="weavyData?.isIhubScreen ? 'Download All' : ''">
          <img [src]="'images/folder-download.svg' | assetUrl" alt="pdf" class="icon-mr-5" />
          <span [hidden]="weavyData?.isIhubScreen && !ihubMaximizeFlag" class="download-posts-button-container-title">{{
            weavyData?.isIhubScreen
            ? "Download All"
            : "Download Policy Docs & Posts"
          }}</span>
        </button>
      }

      @if (!weavyData?.isMobileScreen) {
        <button class="download-posts-button-container" (click)="refreshPosts(true)"
          [matTooltip]="weavyData?.isIhubScreen ? 'Refresh Posts' : ''">
          <img alt="refresh" [src]="'images/refresh.svg' | assetUrl" class="icon-mr-5" />
          <span [hidden]="(weavyData?.isIhubScreen && !ihubMaximizeFlag) || weavyData?.isMobileScreen"
          class="download-posts-button-container-title">Refresh Posts</span>
        </button>
        @if (!weavyData?.isIhubScreen && !isApplicationRunningOnOnItSystem) {
          <button class="download-posts-button-container" (click)="handleFullScreen()"
            [matTooltip]="isFullScreen && weavyData?.isIhubScreen ? 'Minimize' : ''"
            >
            @if (!isFullScreen) {
              <img alt="maximize" [src]="'images/maximize.svg' | assetUrl" class="icon-mr-5" />
            }
            @if (isFullScreen) {
              <img alt="minimize" [src]="'images/minimize.svg' | assetUrl" class="icon-mr-5" />
            }
            <span class="download-posts-button-container-title">{{
              isFullScreen ? "Minimize" : "Full Screen"
            }}</span>
          </button>
        }
      }
      <button class="download-posts-button-container" (click)="notificationSettings()"
        [matTooltip]="weavyData?.isIhubScreen ? 'Notification Settings' : ''">
        <img alt="settings" [src]="'images/settings.svg' | assetUrl" class="icon-mr-5" />
        <span [hidden]="(weavyData?.isIhubScreen && !ihubMaximizeFlag) || weavyData?.isMobileScreen"
        class="download-posts-button-container-title">Notification Settings</span>
      </button>
    </div>
    @if (!showPostDetails) {
      <div class="post-comments-container post-full-screen-posts-container"
        [ngClass]="{ 'ihub-quill-options': weavyData?.isIhubScreen }">
        <div class="container-header">
          <div class="folder-name folder-display-name" [matTooltip]="displayName">
            <span>
              <img [src]="'images/application.svg' | assetUrl" alt="application icom" class="no-width-icon"/>
            </span>
            <span class="display-name" style="display: block;">{{displayName}}</span>
          </div>
          <div class="folder-actions">
            @if (!weavyData?.isMobileScreen) {
              <span class="folder-actions-subscription">{{
                subscribe ? "Subscribed" : ""
              }}</span>
            }
            <span (click)="updatePostSpaceLevelSubscription()" (keypress)="updatePostSpaceLevelSubscription()" [matTooltip]="subscribe ? 'Unsubscribe' : 'Subscribe'">
          <img class="cursor-pointer" [class]="subscribe ? '' : 'icon-grey'" [src]="
              (subscribe ? 'images/bell.svg' : 'images/bell_cross.svg')
                | assetUrl
            " alt="unsubscribe icon" />
              </span>
            </div>
          </div>
          <div class="post-container posts-scroll">
            <div class="editor">
              @if (isPostRender) {
                <exp-quill-rte (updateValueChange)="addPost($event)"></exp-quill-rte>
              }
            </div>
            @if (showLoader || collaborationService.showPostLoader) {
              <collaboration-ui-spinner
              [overlay]="true"></collaboration-ui-spinner>
            }
            @for (post of posts; track trackItemById(i, post); let i = $index) {
              <app-post-details (postDetails)="postDetailsView(post)" (refreshPosts)="handlePostsRefresh($event)"
                (onAddComment)="updateAppSubscribeStatus(true)" [post]="post" [isIhubScreen]="weavyData?.isIhubScreen"
              [isMobileScreen]="weavyData?.isMobileScreen"></app-post-details>
            }
          </div>
        </div>
      }
      @if (showPostDetails) {
        <div>
          <div class="post-details-container details-fullscreen"
            [ngClass]="{ 'ihub-quill-options': weavyData?.isIhubScreen }">
            <div class="container-header">
              <div class="back-arrow">
                <span>
                  <img alt="arrow left" [src]="'images/arrow_left.svg' | assetUrl" (click)="backToPosts()" (keypress)="backToPosts()" class="cursor-pointer"
                    draggable="false" />
                  </span>
                </div>
                <div class="title">Post details</div>
              </div>
              <div class="fs-post-details">
                <app-post-details [isPostDetailView]="true" [post]="selectedPost" [isIhubScreen]="weavyData?.isIhubScreen"
                [isMobileScreen]="weavyData?.isMobileScreen"></app-post-details>
              </div>
            </div>
          </div>
        }
      </div>
    }